import type { PageLayoutProps } from '@spotify/confidence-core-react';

import { resolvePageHeaderLayoutProps } from '../../../../Content/resolvePageHeaderLayoutProps';
import { PageBreadcrumbs } from '../../../../PageBreadcrumbs';
import { useOptionalPageBridgeProps } from '../../../../utils';

type ResourcePageLayoutProps = ReturnType<typeof resolvePageHeaderLayoutProps> &
  Pick<PageLayoutProps, 'narrow'>;

type ResourcePageLayoutOptions = {
  isLoading?: boolean;
  legacyTitle?: PageLayoutProps['title'];
};

export const useResourcePageLayoutProps = ({
  isLoading,
  legacyTitle,
}: ResourcePageLayoutOptions = {}): ResourcePageLayoutProps => {
  const bridgeProps = useOptionalPageBridgeProps();

  if (!bridgeProps?.pageHeader) {
    return {
      title: legacyTitle,
      headerBreadcrumbs: <PageBreadcrumbs />,
      narrow: bridgeProps?.narrow,
    };
  }

  const guardedPageProps = {
    ...bridgeProps,
    hideTitle: undefined,
    pageHeader: {},
  };

  return {
    ...resolvePageHeaderLayoutProps({
      page: guardedPageProps,
      content: {
        isLoading,
        narrow: bridgeProps.narrow,
      },
    }),
    narrow: bridgeProps.narrow,
  };
};
